import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 32px;
`
